"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _lib = require("../../lib");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
var ArcTree = function ArcTree(_ref) {
  var treeData = _ref.treeData,
    checkable = _ref.checkable,
    onExpand = _ref.onExpand,
    expandedKeys = _ref.expandedKeys,
    autoExpandParent = _ref.autoExpandParent,
    onCheck = _ref.onCheck,
    checkedKeys = _ref.checkedKeys,
    onSelect = _ref.onSelect,
    selectedKeys = _ref.selectedKeys,
    showIcon = _ref.showIcon,
    switcherIcon = _ref.switcherIcon,
    showLine = _ref.showLine,
    height = _ref.height,
    loadData = _ref.loadData;
  return /*#__PURE__*/_react["default"].createElement(_lib.Tree, {
    showIcon: showIcon && showIcon,
    checkable: checkable && checkable,
    treeData: treeData,
    onExpand: onExpand && onExpand,
    expandedKeys: expandedKeys && expandedKeys,
    autoExpandParent: autoExpandParent,
    onCheck: onCheck && onCheck,
    checkedKeys: checkedKeys && checkedKeys,
    onSelect: onSelect && onSelect,
    selectedKeys: selectedKeys && selectedKeys,
    switcherIcon: switcherIcon && switcherIcon,
    showLine: showLine && showLine,
    height: height && height,
    loadData: loadData && loadData
  });
};
var _default = ArcTree;
exports["default"] = _default;